import type { SVGProps } from "react";
import { LayoutGrid } from "lucide-react";

export function DashboardIcon(props: SVGProps<SVGSVGElement>) {
  return <LayoutGrid color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
